import Icon from 'veui/components/Icon'
import { IconBackground } from 'dls-icons-vue'

Icon.register('background', IconBackground)
